import React from 'react';

import auth, { Auth } from './modules/auth';
import product, { Product } from './modules/products';

export type RootStore = {
  auth: Auth;
  product: Product;
};

export const store: RootStore = {
  auth,
  product
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth, product };
